<template>
  <div
    class="flex max-lg:flex-col items-center flex-row-reverse justify-between gap-28 lg:*:w-1/2"
  >
    <div class="">
      <h2 class="text-2xl md:text-4xl mb-2 max-md:mb-4 md:mb-4">
        <WrGradientText
          :text="data?.heading"
          append-class="pb-0 md:pb-2 bg-clip-text bg-[linear-gradient(92.15deg,_var(--text-gradient-1)_-1.57%,_var(--text-gradient-2)_30.72%)]"
        />
      </h2>
      <p class="lg:text-xl tracking-[0.5px]">
        {{ data?.subheading }}
      </p>

      <div class="grid sm:grid-cols-2 gap-8 mt-8 mx-12">
        <div
          class="p-2.5 rounded-md flex items-center bg-white dark:bg-[image:var(--bg-inc-button)] [box-shadow:0_1px_1px_0_rgba(7,32,48,.04),_0_2px_10px_0_rgba(0,0,0,.05)]"
          v-for="item in data?.side_box"
        >
          <NuxtImg
            :src="item.image"
            alt="Adonis.js Development Services"
            width="38"
            height="38"
            class="mr-3"
            loading="lazy"
             format="webp"
          />
          <p class="font-medium text-sm" v-html="item.text"></p>
        </div>
      </div>
    </div>
    <NuxtImg
      :src="data?.image"
      alt="Adonis.js Development Services"
      width="565"
      height="423"
      class="[box-shadow:0_2rem_3rem_-1rem_rgba(105,124,161,0.16),0_0_0_0.5rem_#fff] rounded-2xl"
      loading="lazy"
       format="webp"
    />
  </div>
</template>

<script lang="ts" setup>
interface SideBoxItem {
  image: string;
  text: string;
}

interface StatItem {
  figure: string;
  text: string;
}

interface GoogleReview {
  heading: string;
  rating: string;
  stats: StatItem[];
}

interface PartneringData {
  heading: string;
  subheading: string;
  image: string;
  side_box: SideBoxItem[];
  google_review: GoogleReview;
}

// Define props for component
defineProps<{
  data: PartneringData;
}>();
</script>
